<router-outlet></router-outlet>
<ngx-spinner
  bdColor="rgba(0,0,0,0.3)"
  size="medium"
  color="#fff"
  type="ball-spin-clockwise"
  [fullScreen]="true">
</ngx-spinner>